import { useLanguageContext } from '@mbd/ui-components';
import { ApplicationList } from '../features/applications';
import { AppHeader } from '../features/layout';

export function PlatformEntryPage() {
  const { t } = useLanguageContext();

  return (
    <main>
      <AppHeader />
      <h2 style={{ margin: '1rem' }}>{t('welcome_message')}</h2>
      <ApplicationList />
    </main>
  );
}
